import React from "react";
import Preloader from "../helper/Preloader";
import ColorInit from "../helper/ColorInit";
import HeaderOne from "../components/HeaderOne";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import ShippingOne from "../components/ShippingOne";
import OrderConfirmation from "../components/OrderConfirmation";

const OrderConfirmationPage = () => {
    return (
        <>
            <ColorInit color={false} />
            <Preloader />
            <HeaderOne />
            <Breadcrumb title={"Order Confirmation"} />
            <OrderConfirmation />
            <ShippingOne />
            <FooterOne />
            <BottomFooter />
        </>
    );
};

export default OrderConfirmationPage;
